import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';
const {
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE,
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST,
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS,
  SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING,
} = dailySessionNotes;

function* updateSoapNotes(action: any): SagaReturnType<any> {
  try {
    yield put({ type: SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING });

    const response = yield call(dailySessionNotesService.createSoapNote, action.payload);
    if (response?.status === 200) {
      yield put({
        type: PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE, payload: error });
  }
}

function* updateSoapNoteSaga() {
  yield takeEvery(PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST, updateSoapNotes);
}

export default updateSoapNoteSaga;
